"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLatestBillingDateQuery = void 0;
var legacy_queries_1 = require("../../../../shared/api/legacy-queries");
var useLatestBillingDateQuery = function (accountId) {
    var latestBillingQueryResult = (0, legacy_queries_1.useBillingLegacyQuery)(accountId, 'latest');
    if (latestBillingQueryResult.isFetching) {
        return {
            loading: true,
        };
    }
    switch (latestBillingQueryResult.status) {
        case 'no-data':
            return {
                error: 'No Data',
                loading: false,
            };
        case 'error':
            return {
                error: 'Failed to fetch latest billing date',
                loading: false,
            };
        case 'data':
            var billingSummary = latestBillingQueryResult.data.billingSummary;
            var latestBillingEndDate = billingSummary && 'latestPeriod' in billingSummary
                ? billingSummary.latestPeriod.data.end
                : undefined;
            return {
                data: latestBillingEndDate,
                loading: false,
            };
    }
};
exports.useLatestBillingDateQuery = useLatestBillingDateQuery;
